"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetFormatLabels = void 0;
exports.assetFormatLabels = ['imageService', 'assetFormats', (imageService, assetFormats) => {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'modules/images/directives/assetformatlabels.tpl.html',
            scope: {
                image: '='
            },
            link: (scope, element, attrs) => {
                scope.assetFormats = assetFormats;
                scope.hasAssetFormat = (assetFormat) => {
                    if (!scope.image)
                        return false;
                    return scope.image.hasAssetFormat(assetFormat);
                };
                scope.downloadImage = async (imageId, assetFormat) => {
                    await imageService.downloadImage(imageId, assetFormat);
                    return false; // Don't open the href
                };
            }
        };
    }];
